import { render, staticRenderFns } from "./WidgetTableItem.vue?vue&type=template&id=56057e13&scoped=true&"
import script from "./WidgetTableItem.vue?vue&type=script&lang=ts&"
export * from "./WidgetTableItem.vue?vue&type=script&lang=ts&"
import style0 from "./WidgetTableItem.vue?vue&type=style&index=0&id=56057e13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56057e13",
  null
  
)

export default component.exports